export default {
  methods: {
    async check3pQuote(shipping, silent = false) {
      const params = {
        includes: ['provider'],
        area_id_from: shipping.from_area_id,
        area_id_to: shipping.to_area_id,
        company_id_customer: shipping.company_id,
        size_id: shipping.size_id,
        shipping_type_id: shipping.shipping_type_id,
        applies_automatically: 0,
        active: 1
      }
      if (shipping.company_id_provider) {
        params.company_id_provider = shipping.company_id_provider
      }
      return await this.$http.get(this.$appConfig.api.baseUrl + 'outsourcing-quotes/by-params', {params})
        .then(response => {
          return {
            quoteId: response.body.id,
            shippingId: shipping.id,
            provider: response.body.provider.name
          }
        }, () => {
          this.$root.$children[0].$refs.simplert.justCloseSimplert()
          if (!silent) {
            const obj = {
              title: this.$gettext('ERROR'),
              message: this.$gettext('Can\'t be outsourced because there are no matching quotes or rules'),
              type: 'error',
              customCloseBtnText: this.$gettext('Close')
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
            return {
              shippingId: shipping.id
            }
          }
        })
    },
    sendTo3p(quote) {
      if (quote.quoteId && quote.shippingId) {
        const payload = {
          outsourcing_quote_id: quote.quoteId
        }
        return this.$http.post(this.$appConfig.api.baseUrl + 'shippings/' + quote.shippingId + '/outsource', payload)
          .then(response => {
            this.$emit('shippingupdated', response)
            return response
          })
      }
    },
    cancel3p(shipping) {
      return this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + shipping.id + '/insource')
        .then(response => {
          this.$emit('shippingupdated', response)
          return response
        })
    }
  }
}
